export const PAYMENT_PATH = '/payments';
export const CARDS_PATH = `${PAYMENT_PATH}/cards`;

export const TRAVEL_PATH = '/travel';

export const BUDGET_PATH = '/payments/cards';
